<pathPantalla></pathPantalla>

<div [hidden]="consulta">
    <!-- Filtros -->
    <div class="row">
        <div class="col-lg-12" style="padding: 0px">
            <section class="widget">
                <!-- título -->
                <header>
                    <h3> {{sistemaService.NombrePantallaActual}} </h3>
                </header>
                <div class="separador"></div>
                <filtros (filtroAplicado)="SetDatos($event)" [filtros]="filtrosDisplay" [urlApi]="uriApi" #filtrosComponent></filtros>
            </section>
        </div>
    </div>

    <div class="divisor8"></div>

    <div class="row">
        <div class="col-lg-12" style="padding: 0px">
            <section class="widget">
                <!-- tabla -->
                <div>

                  <div class="row" *ngIf="!sistemaService.permisos.edicionespecial">
                    <div class="col-lg-6">
                      <dropdownCustom [titulo]="'Seleccionar vista'" [opciones]="listaopciones" [(ngModel)]="tipo" displayValor="nombre" valorName="id" [buscar]="false"
                      propiedad="id" (ngModelChange)="filtrardatos($event)">
                      </dropdownCustom>
                    </div>
                  </div>

                    <div class="divisor16"></div>

                    <!-- datos -->
                    <dx-data-grid
                        (onOptionChanged)="sistemaService.CambiarPaginacionTabla($event)"
                        id="tabla"
                        [columnAutoWidth]="true"
                        [dataSource]="listaacuerdo"
                        [noDataText]="'Sin Datos'"
                        [showColumnHeaders]="true"
                        (onRowPrepared)="onRowPrepared($event)"
                        >
                        <dxo-export [enabled]="true" [fileName]="sistemaService.NombrePantallaActual" matTooltip="Todo" *ngIf="sistemaService.permisos.exportar"></dxo-export>

                        <dxo-search-panel
                            [visible]="true"
                            [width]="240"
                            placeholder="{{'Buscar' | translate}}">
                        </dxo-search-panel>

                        <dxo-paging [pageSize]="50"></dxo-paging>
                        <!--<dxo-scrolling mode="virtual" [useNative]="false" [showScrollbar]="'always'"></dxo-scrolling>-->
                        <dxo-header-filter [visible]="true"></dxo-header-filter>
                        <dxo-pager
                            [visible]="true"
                            [allowedPageSizes]="sistemaService.tablaPaginacionPaginaSize"
                            [displayMode]="sistemaService.tablaPaginacionModo"
                            [showInfo]="sistemaService.tablaPaginacionInfo"
                            [showNavigationButtons]="sistemaService.tablaPaginacionNavegacion">
                        </dxo-pager>

                        <dxi-column
                            [allowExporting]="false"
                            caption="Acciones"
                            cellTemplate="cellAcciones"
                            alignment="center"
                            [minWidth]="120">

                        </dxi-column>
                        <dxi-column
                            dataField="ciclo"
                            caption="Ciclo">
                        </dxi-column>
                        <dxi-column
                            dataField="periodoevaluacion"
                            caption="Periodo de evaluación">
                        </dxi-column>
                        <dxi-column
                            dataField="nombresubordinado"
                            caption="Persona evaluada">
                        </dxi-column>
                        <dxi-column
                            dataField="puestosub"
                            caption="Puesto">
                        </dxi-column>
                        <dxi-column
                            dataField="departamentosub"
                            caption="Departamento">
                        </dxi-column>
                        <dxi-column
                            dataField="nombrejefe"
                            caption="Jefe">
                        </dxi-column>
                        <dxi-column
                            dataField="firma"
                            caption="Estatus acuerdo">
                        </dxi-column>
                        <dxi-column
                        [allowExporting]="false"
                        caption="Imagen"
                        dataField="urlfotografia"
                        cellTemplate="cellImagenes"
                        alignment="center"
                        [minWidth]="120">

                    </dxi-column>
                        <!-- Acciones -->
                        <div *dxTemplate="let cell of 'cellAcciones'">
                            <a matTooltip="Ver" class="tablaBoton" (click)="Formulario(2, cell.data)">
                                <i class="fa fa-eye fa-lg" aria-hidden="true"></i>
                            </a>
                            <a matTooltip="Editar" class="tablaBoton separado edit" (click)="Formulario(1,cell.data)" *ngIf="sistemaService.permisos.editar && ((cell.data.editarporfecha && cell.data.esjefe) || (cell.data.editarporfecha && cell.data.responsable)) && cell.data.firmado == false">
                                <i class="fa fa-pencil fa-lg" aria-hidden="true"></i>
                            </a>
                        </div>

                        <div *dxTemplate="let cellImagenes of 'cellImagenes'">
                            <div class="imagenPerfilevaluacion" *ngIf="cellImagenes.value">
                                <div class="marcoevaluacion" >
                                    <div class="imagenPanelevaluacion">
                                        <img [src]="cellImagenes.value  | Imagen | async" id="ImagenPerfil" />
                                    </div>
                                </div>
                            </div>
                        </div>

                    </dx-data-grid>

                </div>
            </section>
        </div>
    </div>
</div>

<div #detalleacuerdo></div>
